import styled from "@emotion/styled";

export const WrapperRoot = styled.div`
  position: absolute;
  left: ${({ left = "0" }) => left};
  top: ${({ top = "calc(100% + 16px)" }) => top};

  z-index: 9999999;

  display: flex;
  flex-direction: column;
  width: 276px;
  gap: 4px;
  padding: 8px;

  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${p => p.theme.radii.normal};
  border: 1px solid ${({ theme }) => theme.colors.secondary.stroke};

  @media (max-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    top: ${({ topMobile = "0" }) => topMobile};
  }
`;

export const Wrapper = styled.div`
  max-height: 172px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const StyledInput = styled.input`
  display: flex;
  align-items: flex-start;
  width: 260px;
  padding: 12px 20px;
  gap: 10px;
  align-self: stretch;
  outline: none;

  border-radius: ${p => p.theme.radii.eBid};
  border: ${p => p.theme.borders.input};
  background: ${p => p.theme.colors.background};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;

  padding-right: ${p => p.theme.space[2]}px;
`;

export const Item = styled.li`
  display: flex;
  gap: 10px;
  padding: ${p => p.theme.space[3]}px;
  font-size: ${p => p.theme.fontSizes.s};
  font-weight: ${p => p.theme.fontWeight.medium};
  border-radius: ${p => p.theme.radii.small};
  list-style-type: none;
  cursor: pointer;

  background-color: ${({ isGreen, isHighlighted, theme }) => {
    if (isGreen) return theme.colors.accent.green;
    if (isHighlighted) return theme.colors.background;
  }};

  color: ${({ theme }) => theme.colors.black};

  &:hover {
    background-color: ${({ theme, isGreen }) =>
      isGreen ? theme.colors.accent.green : theme.colors.background};
  }
`;
